import { render, staticRenderFns } from "./UsersNews.vue?vue&type=template&id=196532b8&"
import script from "./UsersNews.vue?vue&type=script&lang=js&"
export * from "./UsersNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports